module.exports = __webpack_public_path__ + "img/img4.4dfdb81d.jpg";